export default {
    select: "选择/Select",
    select_language: "选择语言/Select Language",
    if_already_travelled_in_nepal: '我以前去过尼泊尔/I have travelled to Nepal before',
    language: "语言/Language",
    select_visa_type: "选择签证类型/Select Visa Type",
    select_country: "选择国家/Select your country",
    select_country_of_passport: "Select country (Passport Issuing Country)/选择国家（您的护照签发国家)",
    proceed: "继续/Proceed",
    diplomatic_mission_name: '外交使团名称/Diplomatic Mission Name',
    change_visa_type: "更改签证类型/Change VISA Type",
    middle_name: "中间名字/Middle Name",
    surname: "Surname",
    first_name: "名字/First Name",
    purpose_of_visit: "参观的目的/Purpose Of Visit",
    purpose_of_visa: "签证目的/Purpose Of Visa",
    full_name: "全名/Full Name",
    country: "国家/Country",
    dob: "出生日期/Date Of Birth",
    gender: "性别/Gender",
    cancel: "取消/Cancel",
    ok: "好/OK",
    contact_no_nepal: '联系尼泊尔号码（可选)/Contact Number of Nepal (Optional)',
    address: "地址/Address",
    payment_info: "Payment Info",
    address_in_nepal: "地址在尼泊尔/Address In Nepal",
    full_address: "完整地址/Full Address",
    passport_number: "护照号/Passport Number",
    passport_validity: "护照有效期/Passport Validity",
    passport_image: '护照扫描件/Passport Scanned Copy',
    passport_size_image: '护照尺寸照片/Passport Size Image',
    occupation: "占用/Occupation",
    contact_tel: "Contact No.",
    cell_number: "Cell Phone Number",
    contact_number: "联系电话/Contact  Number",
    confirmation: "确认/Confirmation",
    confirm: "确认/Confirm",
    back: "背部/Back",
    validity_of_visa: "Validity Of Visa",
    visa_duration: "签证期限/Visa Duration",
    visa_period: "Visa Period",
    visa_duration_text_field: "签证期限/Visa Duration",
    personal_information: "个人信息/Personal Information",
    name_of_association: "Name of the association institute",
    visa_expiry_date: 'Visa Expiry date',
    visa_start_date: 'Visa Start date',
    email: "电子邮件/Email",
    email_required: "电子邮件/Email *",
    visa_req_from: "Visa Requested From Date",
    visa_req_to: "Visa Requested To Date",
    name_of_business_institute: "Name of the Business Institution",
    business_detail: "Business Detail",
    business_duration: "Duration of business",
    relationship: "Relationship",
    from: "From",
    staying_at: "住在/Staying At",
    hotel: "旅馆/Hotel",
    other: "其他/Other",
    place: "Place",
    position: "Position",
    dependent_visa_title: "Particulars of the main member of the family in Nepal",
    to: "To",
    husband: "Husband",
    organization_detail: "Organization Detail",
    organization_name: "Organization Name",
    father: "Father",
    mother: "Mother",
    wife: "Wife",
    citizenship: "Citizenship",
    citizenship_number: "Citizenship Number",
    district: "District",
    married_to_nepali_citizen: "Married to Nepalese citizen",
    marriage_details: "Marriage Details",
    date_of_marriage: "Date Of Marriage",
    place_of_marriage: "Place Of Marriage",
    name_of_academic_institution: "Name of the Academic Institution",
    academic_institution: "Academic Institution",
    subject: "Subject",
    permanent_address_home_country: "Permanent Address (Home Country)",
    street_no: "Street No.",
    street_name: "Street Name",
    pin_number: "Pin Number",
    traveller_details: 'Traveller details',
    visa: "Visa",
    reason_for_the_visa: "Reason For The Visa",
    which_field: "Which Field?",
    mention: "Mention?",
    dataIterator: {
        rowsPerPageText: 'Items per page:',
        rowsPerPageAll: 'All',
        pageText: '{0}-{1} of {2}',
        noResultsText: 'No matching records found',
        nextPage: 'Next page',
        prevPage: 'Previous page'
    },
    dataTable: {
        rowsPerPageText: 'Rows per page:'
    },
    noDataText: 'No data available',
    visa_plan: 'Visa Plan',
    enter_visa_detail: 'Enter Visa Detail',
    visa_number: 'Visa Number',
    visa_type: 'Visa Type',
    current_visa_number: '当前签证号码/Current Visa Number',
    search: '搜索/Search',
    change_visa_to: 'Change Visa To',

    select_office: '选择您的入口点/Select your entry point',
    passport_details: '护照资料/Passport Details',
    passport_type: '护照种类/Passport Type',
    visa_option: "签证选项/Visa option",
    has_recommendation_letter: '我有免费签证的推荐信/I have recommendation letter for free visa',
    accompanied_by: '我陪着某人/I am accompanied by somebody',
    visa_cost: "签证费用（美元）/Visa Cost(USD)",
    // proceed_with_online_payment:'继续进行在线付款/Proceed with online payment',
    have_extra_passport: '我也有另一个国家的护照/I have passport of another country as well',
    existing_visa: 'You already have a visa which is not expired on this passport  (For more please reach out to any desk officer).',

    visa_transfer_cost: '签证转移费用（美元）/Visa Transfer Cost (USD)',
    visa_transfer_details: '签证转账详情/Visa Transfer Details',
    reason_for_transfer: '转移原因/Reason for transfer ',
    reason_for_transfer_file: '传输文件的原因/Reason for transfer file ',
    certification_details: '认证详情/Certification Details',
    police_report_or_recommendation: '警察报告/推荐信/Police Report/Letter of Recommendation',
    document_file: '文件档案/Document file',
    arrival_office: '入口点/Entry Point',

    apply_office: '选择您的申请办公室/Select your apply office',
    transport_no: "航班号/Flight/Bus No.",
    plan_upgrade_detail: '签证计划升级详情/Visa plan upgrade detail',
    update_cost: '更新费用/Update cost',
    proceed_with_bank_payment: '在银行付款/Pay at Bank',
    pay_on_arrival: '货到付款/Pay on Arrival',
    charge_detail: 'Surplus  charge will be applied of 1$  while processing from online payment',
    i_am_nrn: '我想申请NRN旅游免费入境签证/I want to apply for NRN tourist gratis entry visa',
    nrn_number: 'NRN编号/NRN number',
    read_the_instruction: '请按照申请表下方的说明进行操作。/Please follow the instruction below the application form.',
    are_you_sure: '你确定吗 ？/Are you sure ?',
    month: '月*/Month * ',
    dob_day: '出生日期：天*/Date of birth:  Day *',
    passport_day: '护照有效期：天*/Passport Validity: Day *',
    year: '年 */Year *',
    check_if_applicable: '仅在适用时检查（可选）/Check only if applicable (Optional)',
    days_staying: '停留天数/Days Staying',
    reason_for_extend: '延期原因/Reason for Extension',
}
